import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AdviserReadWritePermissionModel } from '../../Models/Domains/Users/AdviserReadWritePermissionModel';

declare var IS_RUNNING_IN_APP_POOL;

export class AdviserReadWritePermissionByAccountClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string): Promise<AdviserReadWritePermissionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/User/AdviserReadWritePermissionByAccount/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId }

    return AjaxWrapper.get<AdviserReadWritePermissionModel, any>(url, data);
  }
}

